<template>
  <div id="app">
    <NavBar />
    <router-view/>
    <ErrorModal
      :errorMessage="$store.getters['errors/errorMessage']"
      :visible="$store.getters['errors/visible']"
      @close="clearError"
    />
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import NavBar from './components/NavBar.vue';
import ErrorModal from './components/ErrorModal.vue';
import VueJwtDecode from 'vue-jwt-decode';  
import { useRouter } from 'vue-router';

export default {
  name: 'App',
  components: {
    NavBar,
    ErrorModal
  },
  data() {
    return {
      router : useRouter()
    };
  },
  computed : {
    ...mapState({
      isLoading : state => state.loading,
    }),
    ...mapGetters(['isAuthenticated']),
  },
  methods: {
    clearError() {
      this.$store.dispatch('errors/clearError');
    }
  },
  mounted() {
    const token = localStorage.getItem('token');
    if(token){ 
      const decodedToken = VueJwtDecode.decode(token);
      this.$store.commit('auth/SET_IS_LOGGEDIN', true);
      this.$store.commit('auth/SET_USER',decodedToken.user);
      this.$store.commit('auth/SET_INITIALS', decodedToken.user.name)
    }else{
      this.router.push('/login');
    }
  }
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
